// Italian fantasy names
export const itElfPrefixes = [
    "Aer", "An", "Ar", "Cal", "Cor", "El", "Eru", "Fa", "Fin", "Gal", "Gil", "Hal", "Il", "La", "Leg", "Lo",
    "Mal", "Mor", "Nar", "Nyd", "O", "Pa", "Ra", "Ril", "Sa", "Syl", "Ta", "Th", "Ty", "Val", "Wil", "Xa", "Yr", "Ze",
    "Ael", "Cael", "Dael", "Fael", "Gael", "Kael", "Lael", "Mael", "Nael", "Pael", "Rael", "Sael", "Tael", "Vael",
    "Ad", "Be", "Ce", "De", "Fe", "Ge", "He", "Je", "Ke", "Le", "Me", "Ne", "Pe", "Re", "Se", "Te", "Ve", "We", "Ye", "Ze",
    "Al", "Bel", "Cel", "Del", "Fel", "Gel", "Hel", "Jel", "Kel", "Lel", "Mel", "Nel", "Pel", "Rel", "Sel", "Tel", "Vel", "Wel", "Yel", "Zel"
];

export const itElfSuffixes = [
    "ag", "ar", "as", "bor", "dil", "dor", "drim", "duin", "el", "eth", "fal", "fin", "gal", "gil", "hyl", "ian",
    "il", "in", "lan", "las", "lin", "lion", "lyn", "mar", "mir", "mus", "ndil", "or", "orn", "oth", "qual", "quar",
    "riel", "rin", "ron", "th", "thir", "uil", "um", "we", "wyn", "y", "a", "e", "i", "o", "u", "ae", "ea", "ia",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us", "io", "ia", "io", "ia"
];

export const itMagicPrefixes = [
    "Al", "Bal", "Cor", "Dar", "El", "Ex", "Fal", "Gan", "Ig", "Kas", "Mal", "Mer", "Mor", "Nec", "Oz", "Phi",
    "Ras", "Sar", "Sol", "Thal", "Var", "Xan", "Zar", "Zed", "Zor", "Arc", "Bar", "Car", "Dor", "Er", "Far", "Gor",
    "Har", "Jar", "Kar", "Lor", "Mar", "Nor", "Par", "Qor", "Rar", "Sor", "Tor", "Vor", "War", "Xor", "Yar", "Zor",
    "Alm", "Belm", "Cel", "Delm", "Elm", "Fel", "Gelm", "Helm", "Jelm", "Kelm", "Lelm", "Melm", "Nel", "Pel", "Rel", "Sel", "Tel", "Vel", "Wel", "Yel", "Zel"
];

export const itMagicSuffixes = [
    "agar", "an", "ar", "ax", "bar", "dalf", "din", "dor", "drak", "ius", "kal", "mar", "min", "mond", "nar",
    "or", "os", "rak", "rin", "th", "tor", "us", "zor", "gorn", "dalf", "zar", "zim", "zog", "zum", "zax", "zix",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us", "io", "ia", "io", "ia"
];

export const itDragonPrefixes = [
    "Ag", "Bal", "Chrom", "Dra", "Faf", "Gla", "Ign", "Kal", "Mal", "Ner", "On", "Pha", "Rha", "Sau", "Sma", "Thal",
    "Ver", "Vul", "Xan", "Zyr", "Aer", "Ber", "Cer", "Der", "Fer", "Ger", "Her", "Jer", "Ker", "Ler", "Mer", "Ner",
    "Drag", "Dragu", "Dragi", "Drago", "Dragr", "Dragl", "Dragm", "Dragn"
];

export const itDragonSuffixes = [
    "ar", "ax", "bor", "don", "drax", "gon", "gorn", "ian", "ius", "lax", "lor", "mol", "nos", "or", "oth", "rax",
    "rion", "th", "tor", "us", "ver", "zor", "drog", "grog", "smog", "snog", "zog", "zrog", "zsmog", "zsnog",
    "al", "el", "il", "ol", "ul", "ar", "er", "ir", "or", "ur", "as", "es", "is", "os", "us", "io", "ia", "io", "ia"
];
